import { styled } from '@glitz/react';
import factory from './icon';
import Svg from './glyphs/md-checkmark.svg';

export const CheckIcon = factory(Svg);

export const Check = styled(CheckIcon, {
  verticalAlign: 'text-bottom',
});
